import React from 'react';
import { ArrowRight, Phone, MapPin } from 'lucide-react';
import { Button } from './ui/button';

const Hero = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-gradient-to-br from-[#0a0a0a]/85 via-[#0a0a0a]/80 to-[#1a1a1a]/75 z-10"></div>
        <img
          src="https://images.unsplash.com/photo-1727893119356-1702fe921cf9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHwxfHxjYXIlMjByZXBhaXIlMjBzaG9wfGVufDB8fHx8MTc3NTE2ODM3M3ww&ixlib=rb-4.1.0&q=85"
          alt="Auto Repair Shop"
          className="w-full h-full object-cover opacity-50"
        />
        {/* Decorative gradient spots */}
        <div className="absolute top-1/4 right-0 w-96 h-96 bg-[#ff6b35] rounded-full blur-3xl opacity-10 z-0"></div>
        <div className="absolute bottom-1/4 left-0 w-80 h-80 bg-[#ff6b35] rounded-full blur-3xl opacity-10 z-0"></div>
      </div>

      {/* Content */}
      <div className="relative z-20 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32">
        <div className="max-w-3xl">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 bg-white/5 backdrop-blur-sm border border-[#ff6b35]/30 rounded-full px-4 py-2 mb-8">
            <div className="w-2 h-2 bg-[#ff6b35] rounded-full animate-pulse"></div>
            <span className="text-sm text-gray-300 font-medium">Serving the GTA Since 2002</span>
          </div>

          {/* Main Heading */}
          <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold mb-6 leading-tight">
            <span className="text-white">Premium Auto</span>
            <br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#ff6b35] to-[#ff8c5a]">
              Repairs & Sales
            </span>
          </h1>

          {/* Subheading */}
          <p className="text-xl sm:text-2xl text-gray-400 mb-8 leading-relaxed">
            Professional auto repair services across the GTA. From general repairs to fleet maintenance, 
            we keep your vehicle running at its best.
          </p>

          {/* Location Badge */}
          <div className="flex items-center gap-2 mb-10">
            <MapPin className="w-5 h-5 text-[#ff6b35]" />
            <span className="text-gray-300">21 Millwick Dr, North York, ON M9L 1Y4</span>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4">
            <Button
              onClick={scrollToContact}
              className="bg-[#ff6b35] hover:bg-[#e55a28] text-white font-semibold px-8 py-6 text-lg group"
            >
              Get a Quote
              <ArrowRight className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform duration-200" />
            </Button>
            <a href="tel:416-747-6800">
              <Button
                variant="outline"
                className="border-2 border-white/20 bg-white/5 backdrop-blur-sm hover:bg-white/10 hover:border-[#ff6b35] text-white font-semibold px-8 py-6 text-lg w-full sm:w-auto"
              >
                <Phone className="w-5 h-5 mr-2" />
                416-747-6800
              </Button>
            </a>
          </div>
        </div>
      </div>

      {/* Decorative Elements */}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-[#0a0a0a] to-transparent z-10"></div>
    </section>
  );
};

export default Hero;
